import {
  Grid,
  KebabMenu,
  makeStyles,
  theme
} from '@focaldata/cin-ui-components'
import { SurveyIdProvider } from '../../../../hooks/SurveyIdContext'
import { useSurveyExportMenu } from '../../Survey/ActionsMenu/useSurveyExportMenu'

const useStyles = makeStyles()(() => ({
  // Same inset as the per-market results kebab (controls/ResultsOptions styles),
  // so the three dots line up across the two Results tabs.
  kebabMenu: {
    paddingRight: theme.spacing(1)
  }
}))

// Separate from CombinedExportMenu so the export hooks run inside the provider.
const ExportMenu = ({ language }: { language?: string }) => {
  const { classes } = useStyles()
  const { exportOptions, exportDialog } = useSurveyExportMenu(language)

  return (
    <>
      <Grid item xs="auto" className={classes.kebabMenu}>
        <KebabMenu kebabMenuOptions={exportOptions} />
      </Grid>
      {exportDialog}
    </>
  )
}

/**
 * Export of the shared questionnaire from the project-wide Combined results view.
 * That route carries no `:surveyId`, so the master survey is supplied through
 * SurveyIdContext — a route param would win over it, which is why this may only
 * be mounted on the project-scoped Combined branch. Import is editor-only.
 */
export const CombinedExportMenu = ({
  masterSurveyId,
  language
}: {
  masterSurveyId?: string
  language?: string
}) => {
  if (!masterSurveyId) {
    return null
  }

  return (
    <SurveyIdProvider value={masterSurveyId}>
      <ExportMenu language={language} />
    </SurveyIdProvider>
  )
}
